export { default } from "./billingFooter";
